import { NetworkName } from '@features/lockup/types';
import { shortString } from '@features/lockup/utils/generate-short-string';
import { makeAddressUrl } from '@features/web3/utils/make-address-url';
import { toChainId } from '@features/web3/utils/to-chain-id';
import { AppState } from '@state';
import { CopyLink } from '@uikit/copy-link';
import { EtherscanLink } from '@uikit/etherscan-link';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';

interface Props {
  nameContract: string;
  address: string | undefined | any;
  description: string;
  onClick: () => void;
  isOpen: boolean;
}

const SmartItemMobile = ({ nameContract, address, description, onClick, isOpen }: Props) => {
  const networkName = useSelector<AppState, NetworkName>(state => state.lockup.networkName);

  const linkTitle = ['pulsechainMainnet', 'pulsechainTestnet'].includes(networkName)
    ? 'View on PulseChain Explorer'
    : ['bscMainnet', 'bscTestnet'].includes(networkName)
    ? 'View on BscScan'
    : 'View on Etherscan';

  return (
    <div className={styles.smartItemMobile}>
      <div
        className={styles.smartItemMobileHead}
        onClick={() => {
          onClick();
        }}>
        <p>{nameContract}</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="6"
          viewBox="0 0 10 6"
          className={classNames(isOpen ? styles.rotateIcon : null)}>
          <g fill="none" fillRule="evenodd">
            <g fill="#868e9c" fillRule="nonzero">
              <g>
                <path
                  d="M97.342 19.16c.063.062.098.147.098.236s-.035.174-.098.237l-.707.706c-.06.065-.145.101-.233.101-.089 0-.173-.036-.234-.1l-4.126-4.127c-.094-.094-.147-.221-.147-.354v-.173c0-.133.053-.26.147-.353l4.126-4.127c.06-.064.145-.101.234-.101.088 0 .173.037.233.101l.707.707c.063.062.098.147.098.236 0 .09-.035.174-.098.237l-3.387 3.387 3.387 3.386z"
                  transform="translate(-440 -1091) translate(350 1078) rotate(-90 94.668 15.773)"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      {isOpen && (
        <div className={styles.smartItemMobileContent}>
          <h3>{shortString(address, 14, -14)}</h3>
          <div className={styles.actions}>
            <CopyLink value={address} title={'Copy Address'} />
            <EtherscanLink title={linkTitle} value={makeAddressUrl(toChainId(networkName), address)} />
          </div>
          <p>{description}</p>
        </div>
      )}
    </div>
  );
};

export default SmartItemMobile;
